(function () {
  const replacements = [
    {
      path: "/collections/protocols-and-stacks",
      selector: '.pr_lazy_img.main-img[data-id="55603140624700"]',
      image:
        "https://www.esteemstrong.com/cdn/shop/files/TBBg.webp?v=1764753360&width=1946",
    },
    {
      path: "/collections/tryesteem-products",
      selector:
        "#collection-product > div:nth-child(11) > div > div.product-collection__image.product-image.js-product-images-navigation.js-product-images-hovered-end.cms-hover-image > a > div.pr_lazy_img.main-img",
      image:
        "https://www.esteemstrong.com/cdn/shop/files/TBBg.webp?v=1764753360&width=1946",
    },
  ];

  const current = replacements.find(
    (item) => window.location.pathname === item.path
  );

  if (!current) return;

  function replaceImage() {
    const el = document.querySelector(current.selector);

    if (!el) {
      requestAnimationFrame(replaceImage);
      return;
    }

    // Update background image
    el.style.backgroundImage = `url("${current.image}")`;
    el.setAttribute("data-bgset", current.image);

    // Update <source>
    const source = el.querySelector("source");
    if (source) {
      source.srcset = current.image;
      source.setAttribute("data-srcset", current.image);
    }

    // Update <img>
    const img = el.querySelector("img");
    if (img) {
      img.src = current.image;
      img.srcset = current.image;
    }

    console.log("✅ Image replaced:", current.path);
  }

  replaceImage();
})();